import { Link } from "react-router-dom";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useDynamicSecurityQuestionsOptions } from "hooks/useDynamicSecurityQuestionsOptions";
import FormInputError from "components/General/FormInputError";
import { v4 as uuidv4 } from "uuid";
import { getUserProfile } from "service/userservice/getUserProfile";
import { resetPassword } from "service/userservice/resetPassword";
import { sendEmailNotification } from "service/notificationservice/sendEmailNotification";
import DomainErrorModal from "components/ModalDialogs/DomainErrorModal";
import { sha384 } from "crypto-hash";
import LoadingOverlay from "react-loading-overlay";
import {
  EverlakeLoadingOverlayStyle,
  EverlakeLoadingSpinner,
} from "components/General/EverlakeLoading";
import Countdown from "react-countdown";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import config from "config/config";
import { isAgentPortal } from "js/utilities";
import { useTranslation, Trans } from "react-i18next";

const ResetPassword = () => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm();
  const { t } = useTranslation();
  LoadingOverlay.propTypes = undefined;
  const [openEyePassword, setOpenEyePassword] = useState(true);
  const [openEyeConfirmPassword, setOpenEyeConfirmPassword] = useState(true);
  const [loading, setLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [userEmail, setUserEmail] = useState("");
  const [userId, setUserId] = useState("");
  const [confirmationPassCode, setConfirmationPassCode] = useState("");
  const [errorInfo, seterrorInfo] = useState("");
  const [modalState, setModalState] = useState(false);
  const [question1, setQuestion1] = useState(0);
  const [question2, setQuestion2] = useState(0);
  const [question3, setQuestion3] = useState(0);
  const [answer1, setAnswer1] = useState("");
  const [answer2, setAnswer2] = useState("");
  const [answer3, setAnswer3] = useState("");
  const [userName, setUserName] = useState("");
  const [currentCounterTime, setCurrentCounterTime] = useState(null);
  const [passcodeExpired, setPasscodeExpired] = useState(false);
  const [currentCounterIndex, setCurrentCounterIndex] = useState(0);

  function randomNumberInRange(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const togglePasswordEye = () => {
    setOpenEyePassword(!openEyePassword);
  };

  const toggleConfirmPasswordEye = () => {
    setOpenEyeConfirmPassword(!openEyeConfirmPassword);
  };

  const renderer = ({ minutes, seconds, completed }) => {
    if (completed) {
      setPasscodeExpired(true);
      return (
        <Link
          to=""
          className="mb-4 mr-5"
          onClick={async () => {
            let passcode = randomNumberInRange(100000, 999999);
            setConfirmationPassCode(passcode.toString());
            setLoading(true);
            let securitycode = randomNumberInRange(100000, 999999);
            let sec =
              parseInt(securitycode.toString().substring(3, 4)) === 0
                ? 1
                : parseInt(securitycode.toString().substring(3, 4));
            let confirmationcode = passcode * sec;

            let contentDictionary = {};
            contentDictionary.confirmationcode = confirmationcode.toString();
            contentDictionary.username = userName;
            contentDictionary.securitycode = securitycode.toString();
            isAgentPortal()
              ? await sendEmailNotification(
                  userEmail,
                  12,
                  contentDictionary
                ).catch((error) => {
                  console.log(error);
                })
              : await sendEmailNotification(
                  userEmail,
                  2,
                  contentDictionary
                ).catch((error) => {
                  console.log(error);
                });

            setLoading(false);
            setCurrentCounterTime(
              Date.now() + parseInt(config.OTP_EXPIRY_TIME)
            );
            setCurrentCounterIndex(currentCounterIndex + 1);
            setPasscodeExpired(false);
          }}
        >
          {t("ResetPassword-link-2")}
        </Link>
      );
    } else {
      return (
        <p className="text-sm">
          Code expires in {minutes > 9 ? minutes : "0" + minutes}:
          {seconds > 9 ? seconds : "0" + seconds}
        </p>
      );
    }
  };

  async function onSubmit(data) {
    if (currentStep === 1) {
      setLoading(true);

      let userProfile = await getUserProfile(data.userID).catch((error) => {
        console.log(error);
      });

      setLoading(false);
      if (userProfile === null) {
        seterrorInfo(t("ResetPassword-error-1"));
        setModalState(true);
      } else {
        setUserId(userProfile.userId);
        setUserEmail(userProfile.emailId);
        setUserName(userProfile.firstName);

        if (userProfile.userSecurityAnswers.length > 0) {
          setQuestion1(userProfile.userSecurityAnswers[0].questionId);
          setQuestion2(userProfile.userSecurityAnswers[1].questionId);
          setQuestion3(userProfile.userSecurityAnswers[2].questionId);
          setAnswer1(userProfile.userSecurityAnswers[0].userAnswer);
          setAnswer2(userProfile.userSecurityAnswers[1].userAnswer);
          setAnswer3(userProfile.userSecurityAnswers[2].userAnswer);
          setCurrentStep(currentStep + 1);
        } else {
          let passcode = randomNumberInRange(100000, 999999);
          setConfirmationPassCode(passcode.toString());
          setLoading(true);
          let securitycode = randomNumberInRange(100000, 999999);
          let sec =
            parseInt(securitycode.toString().substring(3, 4)) === 0
              ? 1
              : parseInt(securitycode.toString().substring(3, 4));
          let confirmationcode = passcode * sec;
          let contentDictionary = {};
          contentDictionary.confirmationcode = confirmationcode.toString();
          contentDictionary.username = userProfile.firstName;
          contentDictionary.securitycode = securitycode.toString();
          isAgentPortal()
            ? await sendEmailNotification(
                userProfile.emailId,
                12,
                contentDictionary
              ).catch((error) => {
                console.log(error);
              })
            : await sendEmailNotification(
                userProfile.emailId,
                2,
                contentDictionary
              ).catch((error) => {
                console.log(error);
              });
          setLoading(false);
          setCurrentStep(currentStep + 2);
          setCurrentCounterTime(Date.now() + parseInt(config.OTP_EXPIRY_TIME));
        }
      }
    } else if (currentStep === 2) {
      let enteredanswer1 = (
        await sha384(
          data.securtityAnswerOne.toLowerCase().replaceAll(/\s/g, "")
        )
      )
        .toString()
        .substring(30, 45);

      let enteredanswer2 = (
        await sha384(
          data.securtityAnswerTwo.toLowerCase().replaceAll(/\s/g, "")
        )
      )
        .toString()
        .substring(30, 45);

      let enteredanswer3 = (
        await sha384(
          data.securtityAnswerThree.toLowerCase().replaceAll(/\s/g, "")
        )
      )
        .toString()
        .substring(30, 45);

      if (
        (answer1.toLowerCase() === enteredanswer1 &&
          answer2.toLowerCase() === enteredanswer2) ||
        (answer2.toLowerCase() === enteredanswer2 &&
          answer3.toLowerCase() === enteredanswer3) ||
        (answer1.toLowerCase() === enteredanswer1 &&
          answer3.toLowerCase() === enteredanswer3)
      ) {
        let newPasscode = randomNumberInRange(100000, 999999);
        setConfirmationPassCode(newPasscode.toString());
        setLoading(true);
        let newSecuritycode = randomNumberInRange(100000, 999999);
        let newSec =
          parseInt(newSecuritycode.toString().substring(3, 4)) === 0
            ? 1
            : parseInt(newSecuritycode.toString().substring(3, 4));
        let newConfirmationcode = newPasscode * newSec;
        let newContentDictionary = {};
        newContentDictionary.confirmationcode = newConfirmationcode.toString();
        newContentDictionary.username = userName;
        newContentDictionary.securitycode = newSecuritycode.toString();

        isAgentPortal()
          ? await sendEmailNotification(
              userEmail,
              12,
              newContentDictionary
            ).catch((error) => {
              console.log(error);
            })
          : await sendEmailNotification(
              userEmail,
              2,
              newContentDictionary
            ).catch((error) => {
              console.log(error);
            });

        setLoading(false);
        setCurrentStep(currentStep + 1);
        setCurrentCounterTime(Date.now() + parseInt(config.OTP_EXPIRY_TIME));
      } else {
        seterrorInfo(t("ResetPassword-error-2"));
        setModalState(true);
      }
    } else if (currentStep === 3) {
      if (passcodeExpired) {
        seterrorInfo(t("ResetPassword-error-3"));
        setModalState(true);
      } else {
        if (
          data.resetCode === confirmationPassCode ||
          (config.ENABLE_DEFAULT_OTP === "true" &&
            data.resetCode === config.DEFAULT_OTP)
        ) {
          setCurrentStep(currentStep + 1);
        } else {
          seterrorInfo(t("ResetPassword-error-4"));
          setModalState(true);
        }
      }
    } else if (currentStep === 4) {
      setLoading(true);
      let hashedPassword = (await sha384(data.password))
        .toString()
        .substring(15, 30);
      await resetPassword(userId, hashedPassword)
        .then((data) => {
          setLoading(false);
          setCurrentStep(currentStep + 1);
        })
        .catch((error) => {
          if (error.status && error.status === 403) {
            setLoading(false);
            seterrorInfo(t("ResetPassword-error-5"));
            setModalState(true);
          } else {
            setLoading(false);
            seterrorInfo(t("ResetPassword-error-6"));
            setModalState(true);
            console.log(error);
          }
        });
    }
  }

  const {
    setSecurityQuestionOneId,
    securityQuestionsOne,

    setSecurityQuestionTwoId,
    securityQuestionsTwo,

    setSecurityQuestionThreeId,
    securityQuestionsThree,
  } = useDynamicSecurityQuestionsOptions();

  const uuid = uuidv4();
  return (
    <>
      <LoadingOverlay
        active={loading}
        spinner={<EverlakeLoadingSpinner />}
        styles={EverlakeLoadingOverlayStyle}
      >
        {currentStep === 1 && (
          <form
            onSubmit={handleSubmit(onSubmit)}
            aria-label="reset password form"
          >
            <div className="container ui-component-spacing">
              <div className="ui-card p-4 mx-auto sm:w-2/3 md:w-3/5 lg:w-1/2 md:p-6">
                <h2 className="font-body font-bold text-xl">
                  {t("ResetPassword-formTitle-1")}
                </h2>
                <p className="text-sm">{t("ResetPassword-formSubTitle-1")}</p>
                <div className="mt-4 md:mt-6">
                  <label htmlFor="ID_forgotPasswordUserName">
                    {t("ResetPassword-label-1")}
                  </label>
                  <input
                    id="ID_forgotPasswordUserName"
                    type="text"
                    {...register("userID", {
                      required: {
                        value: true,
                        message: t("ResetPassword-formSubTitle-1"),
                      },
                    })}
                  />
                  {errors.userID && (
                    <FormInputError
                      id={`${uuid}-userID-error`}
                      errorMessage={errors.userID.message}
                    />
                  )}
                </div>
                <div className="text-center mt-4 md:mt-6">
                  <button className="ui-btn-primary ui-btn-min-w">
                    {t("ResetPassword-button-1")}
                  </button>
                  <hr />
                  <Trans
                    i18nKey="ResetPassword-link-1"
                    values={{ email: config.AGENT_SERVICE_EMAIL }}
                    components={{
                      link1: (
                        <Link to="/forgot-username" className="text-xs"></Link>
                      ),
                    }}
                  ></Trans>
                </div>
              </div>
            </div>
          </form>
        )}

        {currentStep === 2 && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="container ui-component-spacing">
              <div className="ui-card p-4 mx-auto sm:w-2/3 md:w-3/5 lg:w-1/2 md:p-6">
                <h2 className="font-body font-bold text-xl">
                  {t("ResetPassword-formTitle-2")}
                </h2>
                <div className="mt-4 md:mt-6">
                  <label id="ID_question1Label">
                    {t("ResetPassword-label-2")}
                  </label>
                  <select
                    disabled
                    id="ID_question1"
                    className="w-full"
                    value={question1}
                    isOptionDisabled={true}
                    {...register("securityQuestionOne", {
                      onChange: (e) =>
                        setSecurityQuestionOneId(parseInt(e.target.value)),
                    })}
                    aria-describedby="ID_question1Error"
                    aria-labelledby="ID_question1Label"
                  >
                    <option value="">{t("ResetPassword-label-3")}</option>
                    {securityQuestionsOne.map((question) => (
                      <option
                        key={`security question - ${question.id}`}
                        value={question.id}
                      >
                        {question.question}
                      </option>
                    ))}
                  </select>
                  {errors.securityQuestionOne && (
                    <FormInputError
                      id={`${uuid}-securityQuestionOne-error`}
                      errorMessage={errors.securityQuestionOne.message}
                    />
                  )}
                </div>
                <div className="mt-4 md:mt-6">
                  <label id="ID_answer1Label">
                    {t("ResetPassword-label-4")}
                  </label>
                  <input
                    id="ID_answer1"
                    className="w-full"
                    type="text"
                    {...register("securtityAnswerOne", {
                      required: {
                        value: true,
                        message: t("ResetPassword-error-8"),
                      },
                    })}
                    aria-describedby="ID_answer1Error"
                    aria-labelledby="ID_answer1Label"
                  />
                  {errors.securtityAnswerOne && (
                    <FormInputError
                      id={`${uuid}-securtityAnswerOne-error`}
                      errorMessage={errors.securtityAnswerOne.message}
                    />
                  )}
                </div>

                <div className="mt-4 md:mt-6">
                  <label id="ID_question2Label">
                    {t("ResetPassword-label-5")}
                  </label>
                  <select
                    disabled
                    id="ID_question2"
                    className="w-full"
                    value={question2}
                    isOptionDisabled={true}
                    {...register("securityQuestionTwo", {
                      onChange: (e) =>
                        setSecurityQuestionTwoId(parseInt(e.target.value)),
                    })}
                    aria-describedby="ID_question2Error"
                    aria-labelledby="ID_question2Label"
                  >
                    <option value="">{t("ResetPassword-label-3")}</option>
                    {securityQuestionsTwo.map((question) => (
                      <option
                        key={`security question - ${question.id}`}
                        value={question.id}
                      >
                        {question.question}
                      </option>
                    ))}
                  </select>
                  {errors.securityQuestionTwo && (
                    <FormInputError
                      id={`${uuid}-securityQuestionTwo-error`}
                      errorMessage={errors.securityQuestionTwo.message}
                    />
                  )}
                </div>
                <div className="mt-4 md:mt-6">
                  <label id="ID_answer2Label">
                    {t("ResetPassword-label-13")}
                  </label>
                  <input
                    id="ID_answer2"
                    className="w-full"
                    type="text"
                    {...register("securtityAnswerTwo", {
                      required: {
                        value: true,
                        message: t("ResetPassword-error-8"),
                      },
                    })}
                    aria-describedby="ID_answer2Error"
                    aria-labelledby="ID_answer2Label"
                  />
                  {errors.securtityAnswerTwo && (
                    <FormInputError
                      id={`${uuid}-securtityAnswerTwo-error`}
                      errorMessage={errors.securtityAnswerTwo.message}
                    />
                  )}
                </div>

                <div className="mt-4 md:mt-6">
                  <label id="ID_question3Label">
                    {t("ResetPassword-label-6")}
                  </label>
                  <select
                    disabled
                    id="ID_question3"
                    className="w-full"
                    value={question3}
                    isOptionDisabled={true}
                    {...register("securityQuestionThree", {
                      onChange: (e) =>
                        setSecurityQuestionThreeId(parseInt(e.target.value)),
                    })}
                    aria-describedby="ID_question3Error"
                    aria-labelledby="ID_question3Label"
                  >
                    <option value="">{t("ResetPassword-label-3")}</option>
                    {securityQuestionsThree.map((question) => (
                      <option
                        key={`security question - ${question.id}`}
                        value={question.id}
                      >
                        {question.question}
                      </option>
                    ))}
                  </select>
                  {errors.securityQuestionThree && (
                    <FormInputError
                      id={`${uuid}-securityQuestionThree-error`}
                      errorMessage={errors.securityQuestionThree.message}
                    />
                  )}
                </div>
                <div className="mt-4 md:mt-6">
                  <label id="ID_answer3Label">
                    {t("ResetPassword-label-7")}
                  </label>
                  <input
                    id="ID_answer3"
                    className="w-full"
                    type="text"
                    {...register("securtityAnswerThree", {
                      required: {
                        value: true,
                        message: t("ResetPassword-error-8"),
                      },
                    })}
                    aria-describedby="ID_answer3Error"
                    aria-labelledby="ID_answer3Label"
                  />
                  {errors.securtityAnswerThree && (
                    <FormInputError
                      id={`${uuid}-securtityAnswerThree-error`}
                      errorMessage={errors.securtityAnswerThree.message}
                    />
                  )}
                </div>
                <div className="text-center mt-4 md:mt-6">
                  <button className="ui-btn-primary ui-btn-min-w">
                    {t("ResetPassword-button-1")}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}

        {currentStep === 3 && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="container ui-component-spacing">
              <div className="ui-card p-4 mx-auto sm:w-2/3 md:w-3/5 lg:w-1/2 md:p-6">
                <h2 className="font-body font-bold text-xl">
                  {t("ResetPassword-formTitle-1")}
                </h2>
                <p className="text-sm">
                  {t("ResetPassword-label-8", {
                    TIME: parseInt(parseInt(config.OTP_EXPIRY_TIME) / 60000),
                  })}
                </p>
                <div className="mt-4 md:mt-6">
                  <label
                    id="ID_passwordResetCodeLabel"
                    htmlFor="ID_passwordResetCode"
                  >
                    {t("ResetPassword-label-9")}
                  </label>
                  <input
                    id="ID_passwordResetCode"
                    aria-labelledby="ID_passwordResetCodeLabel"
                    aria-describedby="ID_passwordResetCodeError"
                    type="text"
                    autoComplete="off"
                    {...register("resetCode", {
                      required: {
                        value: true,
                        message: t("ResetPassword-error-9"),
                      },
                      pattern: {
                        value: /^\d{6}$/,
                        message: t("ResetPassword-error-10"),
                      },
                    })}
                  />
                  {errors.resetCode && (
                    <FormInputError
                      id={`${uuid}-resetCode-error`}
                      errorMessage={errors.resetCode.message}
                    />
                  )}
                </div>
                <div className="mt-4 md:mt-6">
                  <Countdown
                    date={currentCounterTime}
                    key={currentCounterIndex}
                    renderer={renderer}
                  />
                </div>
                <div className="text-center mt-4 md:mt-6">
                  <button className="ui-btn-primary ui-btn-min-w">
                    {t("ResetPassword-button-1")}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}

        {currentStep === 4 && (
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="container ui-component-spacing">
              <div className="ui-card p-4 mx-auto sm:w-2/3 md:w-3/5 lg:w-1/2 md:p-6">
                <h2 className="font-body font-bold text-xl">
                  {t("ResetPassword-formTitle-3")}
                </h2>
                <p className="text-sm">{t("ResetPassword-formSubTitle-2")}</p>
                <ul className="list-disc ml-4">
                  <li>{t("ResetPassword-listpoint-1")}</li>
                  <li> {t("ResetPassword-listpoint-2")}</li>
                  <li> {t("ResetPassword-listpoint-3")}</li>
                  <li> {t("ResetPassword-listpoint-4")}</li>
                  <li>{t("ResetPassword-listpoint-5")}</li>
                </ul>
                <div className="mt-4 md:mt-6 relative">
                  <label id="ID_passwordResetLabel" htmlFor="ID_passwordReset">
                    {t("ResetPassword-label-10")}
                  </label>
                  <input
                    id="ID_passwordReset"
                    aria-labelledby="ID_passwordResetLabel"
                    aria-describedby="ID_passwordResetError"
                    type={openEyePassword ? "password" : "text"}
                    autoComplete="off"
                    {...register("password", {
                      required: t("ResetPassword-error-12"),
                      validate: {
                        minimumCharCount: (v) =>
                          v.length >= 10 || t("ResetPassword-error-12"),
                        maximumCharCount: (v) =>
                          v.length <= 60 || t("ResetPassword-error-12"),
                        hasLowerCaseLetter: (v) =>
                          /^(?=.*[a-z])/.test(v) || t("ResetPassword-error-13"),
                        hasCapitalizedCaseLetter: (v) =>
                          /^(?=.*[A-Z])/.test(v) || t("ResetPassword-error-14"),
                        hasNumericLetter: (v) =>
                          /^(?=.*[0-9])/.test(v) || t("ResetPassword-error-15"),
                        allowedSpecialChars: (v) =>
                          /^(?=.*[!@#\$%&\*\(\)])/.test(v) ||
                          t("ResetPassword-error-16"),
                        illegalLetter: (v) =>
                          v.replace(/[A-Za-z0-9!@#\$%&\*\(\)]/g, "").length <
                            1 || t("ResetPassword-error-17"),
                      },
                    })}
                  />
                  <div className="absolute top-8 right-4">
                    {openEyePassword ? (
                      <AiOutlineEye onClick={togglePasswordEye}></AiOutlineEye>
                    ) : (
                      <AiOutlineEyeInvisible
                        onClick={togglePasswordEye}
                      ></AiOutlineEyeInvisible>
                    )}
                  </div>
                  {errors.password && (
                    <FormInputError
                      id={`${uuid}-password-error`}
                      errorMessage={errors.password.message}
                    />
                  )}
                </div>
                <div className="mt-4 md:mt-6 relative">
                  <label
                    id="ID_passwordResetConfirmLabel"
                    htmlFor="ID_passwordResetConfirm"
                  >
                    {t("ResetPassword-label-11")}
                  </label>
                  <input
                    id="ID_passwordResetConfirm"
                    aria-labelledby="ID_passwordResetConfirmLabel"
                    aria-describedby="ID_passwordResetConfirmError"
                    type={openEyeConfirmPassword ? "password" : "text"}
                    autoComplete="off"
                    {...register("confirmPassword", {
                      validate: (value) => {
                        if (watch("password") !== value) {
                          return t("ResetPassword-label-11");
                        }
                      },
                    })}
                  />
                  <div className="absolute top-8 right-4">
                    {openEyeConfirmPassword ? (
                      <AiOutlineEye
                        onClick={toggleConfirmPasswordEye}
                      ></AiOutlineEye>
                    ) : (
                      <AiOutlineEyeInvisible
                        onClick={toggleConfirmPasswordEye}
                      ></AiOutlineEyeInvisible>
                    )}
                  </div>
                  {errors.confirmPassword && (
                    <FormInputError
                      id={`${uuid}-confirmPassword-error`}
                      errorMessage={errors.confirmPassword.message}
                    />
                  )}
                </div>
                <div className="text-center mt-4 md:mt-6">
                  <button className="ui-btn-primary ui-btn-min-w">
                    {t("ResetPassword-button-2")}
                  </button>
                </div>
              </div>
            </div>
          </form>
        )}

        {currentStep === 5 && (
          <>
            <div className="container ui-component-spacing">
              <div className="ui-card p-4 mx-auto sm:w-2/3 md:w-3/5 lg:w-1/2 md:p-6">
                <h2 className="font-body font-bold text-xl">
                  {t("ResetPassword-formTitle-3")}
                </h2>
                <p className="text-sm">{t("ResetPassword-formSubTitle-3")}</p>
                <div className="text-xl text-center font-semibold mt-4 md:mt-6">
                  {t("ResetPassword-label-12")}
                </div>
                <div className="text-center mt-4 md:mt-6">
                  <Trans
                    i18nKey="ResetPassword-link-3"
                    values={{ email: config.AGENT_SERVICE_EMAIL }}
                    components={{
                      link1: (
                        <Link
                          to="/"
                          className="ui-btn-primary ui-btn-min-w"
                        ></Link>
                      ),
                    }}
                  ></Trans>
                </div>
              </div>
            </div>
          </>
        )}
        <DomainErrorModal
          modalState={modalState}
          setModalState={setModalState}
          errorInfo={errorInfo}
        />
      </LoadingOverlay>
    </>
  );
};

export default ResetPassword;
